import "./Filters.css";

const YearSelector = ({
	availableYears,
	selectedYear,
	onYearChange,
	translate,
}) => {
	return (
		<div className="year-selector">
			<label htmlFor="year-select">{translate("analysis.selectYear")}</label>
			<div className="select-wrapper">
				<select
					id="year-select"
					className="custom-select"
					value={selectedYear}
					onChange={e => onYearChange(parseInt(e.target.value))}
				>
					{availableYears.map(year => (
						<option key={year} value={year}>
							{year}
						</option>
					))}
				</select>
			</div>
		</div>
	);
};

export default YearSelector;
